import { ProgramContent } from "@domain/program/program";
import { ProgramDays } from "@domain/program/program-days";
import { now } from "@utils/date-utils";
import { Dayjs } from "dayjs";

export interface Template extends ProgramContent {
	id: string;
}

export interface TemplateMetadata {
	id: string;
	lastEditionDate: Dayjs;
}

export interface TemplateItem {
	id: string;
	name: string;
	exercisesPerWeek: number;
	sessionsPerWeek: number;
	lastEditionDate: Dayjs;
}

export function getTemplateItemFromTemplate(template: Template, lastEditionDate?: Dayjs): TemplateItem {
	const { id, name, days } = template;
	return {
		id,
		name,
		lastEditionDate: lastEditionDate ?? now(),
		exercisesPerWeek: days.exercisesPerWeek,
		sessionsPerWeek: days.sessionsPerWeek,
	};
}

export interface NewTemplate extends Omit<Template, "id" | "name"> {
	name?: string;
}

export function isTemplate(template: Template | NewTemplate): template is Template {
	// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
	return (template as Template).id !== undefined;
}

export function getEmptyNewTemplate(): NewTemplate {
	return {
		days: new ProgramDays(),
	};
}

export type TemplateOperation = DeleteTemplateOperation | AssignTemplateOperation;

interface DeleteTemplateOperation {
	type: "delete";
	templateName: string;
}

interface AssignTemplateOperation {
	type: "assign";
}
